export const ANIMATION_DURATION = 200

export const FIELD_WIDTH = 330

export const INITIAL_COL_WIDTH = '20px'

export enum HourName {}

export enum DayOfWeek {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7,
}

export const MonthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export enum BrijHexColor {
  Peach = '#f26e60',
  Yellow = '#fbe412',
  Blue = '#48a9bc',
  Red = '#ea2157',
  Orange = '#f28253',
  OceanBlue = '#4f87aa',
  Black = '#323232',
  White = '#fffefc',
  Gold = '#ffcd34',
  Neutral = '#ecece7',
  DarkGrey = '#6d6d6d',
  Brown = '#660012',
  Default = '#fcf9f2',
  SkyBlue = '#f2f5fc',
  LightGrey = '#e2e6f0',
  Mud = '#403434',
  MudDark = '#372C2C',
  Grey = '#c4c4c4',
}
